import i18n from '@src/common/lib/i18n'
import utils from '@src/common/utils'
export const detailTableOption = function () {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: '：',
    align: 'left',
    size: 'small',
    // maxHeight: '100%',
    labelWidth: '100px',
    labelPosition: 'right',
    menuWidth: 200,
    menuAlign: "center",
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 350,
    dialogWidth: '640px',
    emptyText: '暂无数据',
    menu: false,
    column: [{
      label: '调查项',
      prop: 'dcItem',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      align: 'center',
    },
    {
      label: '选项/频次',
      prop: 'dcRate1',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      align: 'center'
    },
    {
      label: '选项/频次',
      prop: 'dcRate2',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      align: 'center'
    },
    {
      label: '选项/频次',
      prop: 'dcRate3',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      align: 'center'
    },
    {
      label: '选项/频次',
      prop: 'dcRate4',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      align: 'center'
    },
    {
      label: '选项/频次',
      prop: 'dcRate5',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      align: 'center'
    },
  ],
  }
}